import * as ActionTypes from '../../actions/ActionTypes';
import ArticleContentRecord from '../../records/edit/ArticleContentRecord';
import { ERROR_TYPES } from '../../constants/ApiErrorConstants';
import Article from '../../records/ArticleRecord';
export function getIsEditorReadOnly(state) {
  return ERROR_TYPES.ARTICLE_OPTIMISTIC_LOCKING_HANDLED_TYPES.includes(state.updateErrorType);
}
export default function articleContentInfo(state = new ArticleContentRecord(), action) {
  switch (action.type) {
    case ActionTypes.ATTACH_TO_LANG_MASTER_SUCCESS:
      return state.merge({
        article: new Article(action.payload.data),
        lastEditTicks: action.payload.headers['x-last-modified-timestamp']
      });
    case ActionTypes.DETACH_FROM_LANGUAGE_GROUP_EDITOR_SUCCESS:
      {
        return state.merge({
          article: state.article.setIn(['values', 'hs_translated_from_id'], undefined).set('translations', {}),
          lastEditTicks: action.payload.headers['x-last-modified-timestamp']
        });
      }
    case ActionTypes.FETCH_ARTICLE_EDIT_INFO_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.FETCH_ARTICLE_EDIT_INFO_SUCCESS:
      {
        return state.merge({
          article: new Article(action.payload.article),
          isRequesting: false,
          lastLoaded: new Date().valueOf(),
          lastEditTicks: action.payload.lastEditTicks,
          hasBufferedChanges: !!action.payload.hasChanges,
          hasLocalChanges: false
        });
      }
    case ActionTypes.FETCH_ARTICLE_EDIT_INFO_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error,
        hasBufferedChanges: false
      });
    case ActionTypes.CLEAR_ARTICLE_EDIT_INFO:
      return new ArticleContentRecord();
    case ActionTypes.PRE_PUBLISH_ARTICLE:
      return state.merge({
        error: undefined,
        isPrePublishing: true,
        isPublishing: false
      });
    case ActionTypes.PUBLISH_ARTICLE_PENDING:
      return state.merge({
        error: undefined,
        isPrePublishing: false,
        isPublishing: true
      });
    case ActionTypes.PUBLISH_ARTICLE_SUCCESS:
      return state.merge({
        error: undefined,
        isPrePublishing: false,
        isPublishing: false
      });
    case ActionTypes.PUBLISH_ARTICLE_ERROR:
      return state.merge({
        error: action.error,
        isPrePublishing: false,
        isPublishing: false
      });
    case ActionTypes.UPDATE_ARTICLE_PENDING:
      return state.merge({
        error: undefined,
        isUpdating: true,
        isUpdated: false,
        sessionUpdateId: state.sessionUpdateId + 1
      });
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_PENDING:
      return state.merge({
        error: undefined,
        isUpdating: true,
        isUpdated: false
      });
    case ActionTypes.UPDATE_ARTICLE:
      return state.setIn(['article'], new Article(Object.assign({}, state.article.toJS(), action.payload)));
    case ActionTypes.UPDATE_ARTICLE_SUCCESS:
      {
        const currentArticleId = state.getIn(['article', 'id']);
        if (currentArticleId && currentArticleId !== action.payload.data.id) {
          return state.merge({
            error: undefined,
            isUpdating: false,
            isUpdated: true
          });
        }
        const article = new Article(action.payload.data).setIn(['values', 'hs_access_rule_ids'], state.article.values.hs_access_rule_ids);
        return state.merge({
          article,
          error: undefined,
          hasBufferedChanges: true,
          hasLocalChanges: true,
          isUpdating: false,
          isUpdated: true,
          lastLoaded: new Date().valueOf(),
          lastEditTicks: action.payload.headers['x-last-modified-timestamp']
        });
      }
    case ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_SUCCESS:
      return state.setIn(['article', 'values', 'hs_knowledge_category_id'], action.payload.categoryIdToBeTranslated);
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_SUCCESS:
      return state.update('article', article => article.updateVisibility(action.payload.data)).merge({
        error: undefined,
        hasBufferedChanges: true,
        hasLocalChanges: true,
        isUpdating: false,
        isUpdated: true,
        lastLoaded: new Date().valueOf(),
        lastEditTicks: action.payload.headers['x-last-modified-timestamp']
      });
    case ActionTypes.UPDATE_ARTICLE_ERROR:
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_ERROR:
      {
        const {
          error
        } = action;
        const {
          responseJSON = {}
        } = error;
        const {
          updateErrorType,
          updatedUserName
        } = responseJSON;
        return state.merge({
          error: action.error,
          isUpdating: false,
          isUpdated: false,
          updateErrorType: updateErrorType || null,
          updatedUsername: updatedUserName || null
        });
      }
    default:
      return state;
  }
}